import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';

import { InvoicesPanelProps } from './InvoicesPanel.props';
import { Panel } from '../../../../../components/atoms/Panel';

const COLUMNS = ['Invoice #', 'Date', 'Amount', 'Status'];

const cellSx = { fontSize: '12px', py: 1, px: 1.5 };
const headerSx = {
  ...cellSx,
  fontWeight: 600,
  bgcolor: 'v4.tableEven',
  borderBottom: 1,
  borderColor: 'v4.border',
};

const InvoiceTable: React.FC<{
  title: string;
  rows: Array<Record<string, unknown>>;
}> = ({ title, rows }) => (
  <Box>
    <Typography sx={{ fontSize: '12px', fontWeight: 600, mb: 1 }}>
      {title}
    </Typography>
    {rows.length === 0 ? (
      <Typography
        sx={{ fontSize: '12px', color: 'text.secondary', py: 1 }}
      >
        No invoices
      </Typography>
    ) : (
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((col) => (
                <TableCell key={col} sx={headerSx}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow
                key={String(row.id ?? idx)}
                sx={{
                  bgcolor: idx % 2 === 1 ? 'v4.tableEven' : 'transparent',
                }}
              >
                <TableCell sx={cellSx}>
                  {String(row.invoiceNumber ?? row.number ?? '-')}
                </TableCell>
                <TableCell sx={cellSx}>
                  {String(row.date ?? '-')}
                </TableCell>
                <TableCell sx={cellSx}>
                  {String(row.amount ?? '-')}
                </TableCell>
                <TableCell sx={cellSx}>
                  {String(row.status ?? '-')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);

export const InvoicesPanel: React.FC<InvoicesPanelProps> = ({
  internalInvoices = [],
  externalInvoices = [],
}) => (
  <Panel title="Invoices">
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <InvoiceTable title="Internal Invoices" rows={internalInvoices} />
      <InvoiceTable title="External Invoices" rows={externalInvoices} />
    </Box>
  </Panel>
);
